export const shouldAutoplayHelpVideo = (openedByUser) => openedByUser === true;
